import { Button, DialogActions } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { ReactElement, useContext, useEffect } from "react";

import useText from "../../hooks/use-text";
import { FilesContext } from "../../providers/files-provider";
import { UploadContext } from "../../providers/upload-provider";
import { LocalizedStrings, SupportedLanguages } from "../../utils/lang";

type Props = {
  onClose(): void;
};

export default function UploadModalFooter(props: Props): ReactElement {
  const { onClose } = props;

  const { strings } = useText(local);
  const { upload, files, isCreateAssetLoading, errors } =
    useContext(UploadContext);
  const { assetsChanged } = useContext(FilesContext);

  useEffect(() => {
    if (errors.length !== 0) {
      enqueueSnackbar(strings.errors.general, { variant: "error" });
    }
  }, [errors]);

  return (
    <DialogActions>
      <Button color="secondary" onClick={onClose}>
        {strings.cancel}
      </Button>
      <Button
        disabled={files.length === 0 || isCreateAssetLoading}
        onClick={async () => {
          await upload();
          assetsChanged();
          onClose();
        }}
      >
        {strings.upload}
      </Button>
    </DialogActions>
  );
}

type LocalSchema = {
  cancel: string;
  upload: string;
  errors: {
    general: string;
  };
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    cancel: "Cancel",
    upload: "Upload",
    errors: {
      general: "Failed to upload assets. Please retry it again.",
    },
  },
};
